import api from './axios';
import { getToken } from './auth';
import { getCookie } from "../utils/csrf";

// Create payment intent for subscription renewal
export const createPaymentIntent = async (planId, planSpan) => {
  const csrftoken = getCookie("csrftoken");  // <-- read token

  const response = await api.post(
    "/core/payment/create-intent/",
    {
      plan_id: planId,
      plan_span: planSpan,
    },
    {
      headers: {
        "X-CSRFToken": csrftoken,        // <-- ADD IT HERE
        "Content-Type": "application/json",
      },
      withCredentials: true,             // IMPORTANT if domains are different
    }
  );

  return response.data;
};

// Confirm payment after Stripe processing
export const confirmPayment = async (paymentIntentId) => {
    if (!paymentIntentId) throw new Error("Payment Intent ID is required");
    const token = getToken();
    const response = await api.post(
      '/core/payment/confirm/',
      { payment_intent_id: paymentIntentId },
      token ? { headers: { Authorization: `Token ${token}` } } : undefined
    );
    return response.data;
};
  

// Get payment history
export const getPaymentHistory = async () => {
    const response = await api.get('/core/payment/history/');
    return response.data;
};

